import React, {useEffect, useState} from "react";
import WorkForceCaseComponent from "../../../components/WorkForce/WorkForceCaseComponent";
import CaseDetailsComponent from "./CaseDetailsComponent";
import AlarmCaseDetails from "./CaseDetails/AlarmCaseDetails";
import MeterLoggerCaseDetails from "./CaseDetails/MeterLoggerCaseDetails";
import DownloadDataManualReadCaseDetails from "./CaseDetails/DownloadDataManualReadCaseDetails";
import {useNavigate, useParams} from "react-router-dom";
import {Button} from "antd";

const CreateCasePage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [workforceType, setWorkforceType] = useState(0);

    const handleRedirectToCaseListing = () => {
        navigate('/wf-case-listing');
    };

    return (
        <>
            <div className="p-4">
                <div className="grid grid-cols-2">
                    <div className="flex flex-col gap-5 py-3 w-8/12">
                        <div className={"grid grid-cols-2"}>
                            <p className="font-bold">Create New Case</p>
                            <div className={"flex justify-end"}>
                                <Button
                                    onClick={handleRedirectToCaseListing}
                                    className="col-end-6 bg-medium-grey-100 text-white hover:bg-dark-grey"
                                    type={"button"}
                                    variant="solid"
                                >
                                    Back
                                </Button>
                            </div>
                        </div>
                        <WorkForceCaseComponent
                            text={"Alarm"}
                            imgPath={"/assets/workforce-assets/alarm.svg"}
                            imgAltText="sign with an exclaimation mark in the middle"
                            workforceValue={1}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Meter Replacement"}
                            imgPath={"/assets/workforce-assets/meter-replacement.svg"}
                            imgAltText="a water meter with a loading circle"
                            workforceValue={2}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Logger Replacement"}
                            imgPath={"/assets/workforce-assets/alarm.svg"}
                            imgAltText="a logger with signal"
                            workforceValue={3}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Sim-Card Replacement"}
                            imgPath={"/assets/workforce-assets/simcard-replacement.svg"}
                            imgAltText="a simcard"
                            workforceValue={4}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Meter Inspection"}
                            imgPath={"/assets/workforce-assets/meter-inspection.svg"}
                            imgAltText="a water meter with a tick"
                            workforceValue={5}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Clamp-On"}
                            imgPath={"/assets/workforce-assets/clamp-on.svg"}
                            imgAltText="a device for clamping objects"
                            workforceValue={6}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Download Data"}
                            imgPath={"/assets/workforce-assets/download-data.svg"}
                            imgAltText="download document"
                            workforceValue={7}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                        <WorkForceCaseComponent
                            text={"Manual Read"}
                            imgPath={"/assets/workforce-assets/manual-read.svg"}
                            imgAltText="a magnifying glass"
                            workforceValue={8}
                            workforceType={workforceType}
                            setWorkforceType={setWorkforceType}
                        />
                    </div>
                    <div className="w-full py-3">
                        {(workforceType !== 0 || id !== undefined) && <CaseDetailsComponent createCaseId={id ?? workforceType}/>}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateCasePage;
